import { createSlice } from "@reduxjs/toolkit";

/**
 * Load from localStorage (ONLY if exists)
 */
const storedToken = localStorage.getItem("adminToken");
const storedRole = localStorage.getItem("adminRole");
const storedPermissions = localStorage.getItem("adminPermissions");

/**
 * IMPORTANT:
 * - permissions = null means "still loading / not decided"
 * - permissions = [] means "decided but no permissions"
 */
const initialState = {
  adminToken: storedToken || null,
  adminRole: storedRole || null,
  adminPermissions: storedPermissions ? JSON.parse(storedPermissions) : null, // 🔴 KEY FIX
};

const adminAuthSlice = createSlice({
  name: "adminAuth",
  initialState,
  reducers: {
    setAdminAuth(state, action) {
      const { token, role, permissions } = action.payload;

      state.adminToken = token;
      state.adminRole = role;
      state.adminPermissions = permissions ?? [];

      // persist
      localStorage.setItem("adminToken", token);
      localStorage.setItem("adminRole", role);
      localStorage.setItem(
        "adminPermissions",
        JSON.stringify(permissions ?? []),
      );
    },

    adminLogout() {
      localStorage.removeItem("adminToken");
      localStorage.removeItem("adminRole");
      localStorage.removeItem("adminPermissions");

      return {
        adminToken: null,
        adminRole: null,
        adminPermissions: null,
      };
    },
  },
});

export const { setAdminAuth, adminLogout } = adminAuthSlice.actions;
export default adminAuthSlice.reducer;
